import React from "react";
import { useSelector } from "react-redux";
import { getObjectByKey } from "../../../utils/utils";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import htcWidgetImg from "../../../../assests/htc/htcWidget.png";

const HtcCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const { platforms } = useSelector(state => state.uiData);
    const htc = getObjectByKey("htc", platforms);

    return (
        <WidgetCarouselCard
            color="#39B6A9"
            titleColor="#FFF"
            title={texts.htc}
            image={htcWidgetImg}
            imageAlt={texts.htc}
            link={htc?.link}
        />
    );
};

export default HtcCarouselWidget;
